import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';

@Injectable()
export class AppUrl {

  static get STUDENT_URL(): string {
    return environment.appUrl + 'student/';
  }

  static get LOGIN(): string {
    return AppUrl.STUDENT_URL + 'login';
  }

  static get SELF(): string {
    return AppUrl.STUDENT_URL + 'self';
  }

  static UPDATE_SELF(): string {
    return AppUrl.STUDENT_URL + 'update-self';
  }

  static LOGOUT(): string {
    return AppUrl.STUDENT_URL + 'logout';
  }

  static FILE_UPLOAD(): string {
    return AppUrl.STUDENT_URL + 'file-upload';
  }

  static UPDATE_USER_PASSWORD(): string {
    return AppUrl.STUDENT_URL + 'update-user-password';
  }

  static COURSES(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'course/' + id;
    } else {
      return AppUrl.STUDENT_URL + 'course';
    }
  }

  static CENTER_BRANCH(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'center-branch/' + id;
    } else {
      return AppUrl.STUDENT_URL + 'center-branch';
    }
  }

  static CENTER_BRANCH_PASSWORD(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'center-branch-password/' + id;
    }
  }

  static CENTER_BRANCH_STATUS(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'center-branch-status/' + id;
    }
  }
  static GET_BRANCH_SHARE_PERCENTAGE(): string {
    return AppUrl.STUDENT_URL + 'branch-share-percentage';
  }

  static UPDATE_BRANCH_SHARE_PERCENTAGE(user_id, session_id): string {
    return AppUrl.STUDENT_URL + 'update-branch-share-percentage/' + user_id + '/' + session_id;
  }

  static STATES(): string {
    return AppUrl.STUDENT_URL + 'states';
  }

  static STUDENT(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'student/' + id;
    } else {
      return AppUrl.STUDENT_URL + 'student';
    }
  }

  static RESEND_OTP_STUDENT(): string {
    return AppUrl.STUDENT_URL + 'resend-otp-student';
  }

  static VERIFY_OTP_STUDENT(): string {
    return AppUrl.STUDENT_URL + 'verify-otp-student';
  }

  static PERSONAL_INFO(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'personal-info/' + id;
    } else {
      return AppUrl.STUDENT_URL + 'personal-info';
    }
  }

  static TRANSLATE_TEXT(): string {
    return AppUrl.STUDENT_URL + 'translate-text';
  }

  static PERSONAL_INFO_PHOTOGRAPH_UPDATE(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'personal-info-photograph/' + id;
    }
  }

  static PERSONAL_INFO_GOVT_PHOTO_ID_UPDATE(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'personal-info-govt-photo-id-proof/' + id;
    }
  }

  static ADDRESS(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'address/' + id;
    } else {
      return AppUrl.STUDENT_URL + 'address';
    }
  }

  static ACADEMIC_DETAILS(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'academic-details/' + id;
    } else {
      return AppUrl.STUDENT_URL + 'academic-details';
    }
  }

  static ACADEMIC_DETAILS_TENTH_CERTIFICATE_UPDATE(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'academic-details-tenth-certificate/' + id;
    }
  }

  static ACADEMIC_DETAILS_TWELTH_CERTIFICATE_UPDATE(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'academic-details-twelth-certificate/' + id;
    }
  }

  static MORE_QUALIFICATION(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'more-qualification/' + id;
    } else {
      return AppUrl.STUDENT_URL + 'more-qualification';
    }
  }

  static MORE_QUALIFICATION_GRADUATION_CERTIFICATE_UPDATE(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'more-qualification-graduation-certificate/' + id;
    }
  }

  static MORE_QUALIFICATION_POST_GRADUATION_CERTIFICATE_UPDATE(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'more-qualification-post-graduation-certificate/' + id;
    }
  }

  static MORE_QUALIFICATION_OTHER_QUALIFICATION_CERTIFICATE_UPDATE(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'more-qualification-other-qualification-certificate/' + id;
    }
  }

  static PROGRAMS(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'program/' + id;
    } else {
      return AppUrl.STUDENT_URL + 'program';
    }
  }

  static PCB_MAPPINGS(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'pcb-mapping/' + id;
    } else {
      return AppUrl.STUDENT_URL + 'pcb-mapping';
    }
  }

  static COURSE_DETAILS(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'course-details/' + id;
    } else {
      return AppUrl.STUDENT_URL + 'course-details';
    }
  }

  static COURSE_CURRICULUM(id?): string {
    if (id) {
      return AppUrl.STUDENT_URL + 'course-curriculum/' + id;
    } else {
      return AppUrl.STUDENT_URL + 'course-curriculum';
    }
  }
}
